import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppState } from 'state/hooks/app.state.hook';
import { useStoreSettings } from '../../../hooks/useStoreSettings';

interface ISimpleTermsProps {
  privacyPolicyLink?: string;
  termsAndConditionsLink?: string;
}

export const SimpleTerms: React.FC<ISimpleTermsProps> = ({
  privacyPolicyLink,
  termsAndConditionsLink,
}) => {
  const { openInfoModal } = useAppState();
  const { t } = useTranslation();
  const { footer: footerSettings } = useStoreSettings();
  const openInNewTab = footerSettings.openLinksInNewTab || false;

  return (
    <span data-testid="login-page-terms-block" className="terms-wrapper">
      {t('login.byLoggingIn')}{' '}
      <span
        className={'login-link'}
        onClick={() => {
          openInNewTab
            ? window.open(privacyPolicyLink, '_blank')
            : openInfoModal(privacyPolicyLink);
        }}
      >
        {t('login.privacyPolicy')}
      </span>{' '}
      {t('login.and')}{' '}
      <span
        className={'login-link'}
        onClick={() => {
          openInNewTab
            ? window.open(termsAndConditionsLink, '_blank')
            : openInfoModal(termsAndConditionsLink);
        }}
      >
        {t('login.termsAndConditions')}
      </span>
    </span>
  );
};
